import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import '../accordion/style.css';
import './style.css';

const FaqItem = ({ item, index, isOpen, onToggle }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(isOpen ? contentRef.current.scrollHeight : 0);
  }, [isOpen]);

  const num = String(index + 1).padStart(2, '0');

  return (
    <div className={`acc-item ${isOpen ? 'acc-item--open' : ''}`}>
      <button className="acc-trigger acc-trigger--faq" onClick={onToggle} aria-expanded={isOpen}>
        <span className="acc-num">{num}</span>
        <span className="acc-title">{item.question}</span>
        <span className="acc-chevron">{isOpen ? '−' : '+'}</span>
      </button>
      <div className="acc-body" style={{ height: `${height}px` }}>
        <div className="acc-body-inner acc-body-inner--faq" ref={contentRef}>
          <p className="acc-answer">{item.answer}</p>
        </div>
      </div>
    </div>
  );
};

const FAQSection = () => {
  const { t } = useTranslation('gallery');
  const [openIndex, setOpenIndex] = useState(null);
  const faqs = t('faq.items', { returnObjects: true });

  return (
    <section className="faq section">
      <div className="container">
        <h2 className="title-2">
          {t('faq.title')} <span className="accent">{t('faq.titleAccent')}</span>
        </h2>
        <p className="faq-subtitle">{t('faq.subtitle')}</p>

        <div className="accordion__container">
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              item={faq}
              index={index}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>

        <div className="faq-cta">
          <p>{t('faq.cta.text')}</p>
          <div className="faq-contact-options">
            <a href="https://wa.me/358468130887" className="button btn-primary" target="_blank" rel="noopener noreferrer">
              {t('faq.cta.whatsapp')}
            </a>
            <NavLink to="/contacts" className="button">
              {t('faq.cta.email')}
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export { FAQSection };
